import React, { useState, useEffect } from 'react';
import GlobalUploadComp from '../../../common/components/GlobalUploadComp/GlobalUploadComp';
import initialImg from '../../../images/icons/upload_new.svg';
import { useFormikContext } from 'formik';
import PopUp from '../../../common/components/PopUp/PopUp';
import {
  getUploadUrlForBusinessAddressProof,
  UploadFileToS3,
  confirmBusinessAddressProofUploaded,
  getBusinessAddressProof,
  getUploadUrlForBusinessProofLLP,
  getSelpEmployeedDetails
} from '../../../common/constants/api';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import { ShowGetImage } from '../../../common/components/ShowGetImage/ShowGetImage';

import * as _ from 'lodash';
let docs = {
  moa: {
    docname: ' MOA',
    index: 0,
    name: 'moa'
  },
  aoa: {
    docname: ' AOA',
    index: 1,
    name: 'aoa'
  },
  board_res: {
    docname: ' Board resolution',
    index: 2,
    name: 'board_res'
  },
  sahre_pattern: {
    docname: 'Share Holding pattern',
    index: 3,
    name: 'sahre_pattern'
  },
  reg_certificate: {
    docname: 'Company Registration Certificate',
    index: 4,
    name: 'reg_certificate'
  },
  llpagreement: {
    docname: 'LLP Agreement',
    index: 5,
    name: 'llpAgreement'
  },
  partnerShipDeed: {
    docname: 'Partnership deed',
    index: 6,
    name: 'partnershipdeed'
  }
};
const SENPDocuments = () => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    validateForm
  } = useFormikContext();

  const [requiredDocument, setRequiredDocs] = useState([]);
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);
  const [moaFile, setMOAFile] = useState('');
  const [aoaFile, setAOAFile] = useState('');
  const [boardResFile, setBoardRes] = useState('');
  const [shareHoldFile, setShareHoldFile] = useState('');
  const [regCertificate, setRegCertificate] = useState('');
  const [llpinAgreement, setLLPINAgreement] = useState('');
  const [partnerShipDeed, setPartnerShipDeed] = useState('');

  const [preValues, setPrevalues] = useState(values.preValues());

  useEffect(() => {
    setFieldValue('allValues', values.preValues());
  }, []);
  const docList = [
    'moa',
    'aoa',
    'board-resolution',
    'share-holding',
    'registration-certificate',
    'llp-agreement',
    'partnership-deed'
  ];

  useEffect(() => {
    if (values.step && values.step == 'LAP') {
      setRequiredDocs([
        docs.moa,
        docs.aoa,
        docs.sahre_pattern,
        docs.reg_certificate
      ]);
    } else if (_.get(preValues, 'companyDetails.companyType', false)) {
      if (
        preValues.companyDetails.companyType == 'Limited' ||
        preValues.companyDetails.companyType == 'Private Limited'
      )
        setRequiredDocs([
          docs.moa,
          docs.aoa,
          docs.board_res,
          docs.sahre_pattern,
          docs.reg_certificate
        ]);
      else if (preValues.companyDetails.companyType == 'LLP') {
        setRequiredDocs([docs.llpagreement, docs.reg_certificate]);
      } else if (preValues.companyDetails.companyType == 'Proprietorship') {
        setRequiredDocs([docs.reg_certificate]);
      } else if (preValues.companyDetails.companyType == 'Partnership') {
        setRequiredDocs([docs.partnerShipDeed, docs.reg_certificate]);
      }
    }
  }, [preValues.companyDetails, values.step]);

  const getSubmittedData = docName => {
    setType('loading');
    setText('Getting uploaded data Please Wait..');
    setShow(true);

    getBusinessAddressProof(
      getApplicantionInfo().leadId,
      getApplicantionInfo().leadApplicantId,
      docName
    )
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        let index = docList.indexOf(docName);
        if (index == 0) {
          setMOAFile(_.get(res, 'links.0.url', false));
          setFieldValue('moaFile', _.get(res, 'links.0.url', false));
        } else if (index == 1) {
          setAOAFile(_.get(res, 'links.0.url', false));
          setFieldValue('aoaFile', _.get(res, 'links.0.url', false));
        } else if (index == 2) {
          setBoardRes(_.get(res, 'links.0.url', false));
          setFieldValue('boardsres', _.get(res, 'links.0.url', false));
        } else if (index == 3) {
          setShareHoldFile(_.get(res, 'links.0.url', false));
          setFieldValue('shareHolders', _.get(res, 'links.0.url', false));
        } else if (index == 4) {
          setRegCertificate(_.get(res, 'links.0.url', false));
          setFieldValue('regCertificate', _.get(res, 'links.0.url', false));
        } else if (index == 5) {
          setLLPINAgreement(_.get(res, 'links.0.url', false));
          setFieldValue('llpin', _.get(res, 'links.0.url', false));
        } else if (index == 6) {
          setPartnerShipDeed(_.get(res, 'links.0.url', false));
          setFieldValue('partnershipdeed', _.get(res, 'links.0.url', false));
        }

        if (values.neededDocs.indexOf(docName) < values.neededDocs.length - 1) {
          getSubmittedData(
            values.neededDocs[values.neededDocs.indexOf(docName) + 1]
          );
        }
        if (
          values.neededDocs.indexOf(docName) ==
          values.neededDocs.length - 1
        ) {
          setShow(false);
        }
      })
      .catch(error => {
        setShow(false);
      });
  };

  useEffect(() => {
    if (_.get(preValues, 'companyDetails.companyType', true)) {
      setType('loading');
      setText('Getting uploaded data Please Wait..');
      setShow(true);
      getSelpEmployeedDetails(
        getApplicantionInfo().leadId,
        getApplicantionInfo().leadApplicantId
      )
        .then(res => {
          setShow(false);
          setPrevalues({
            companyDetails: res,
            step: 'SENP'
          });
        })
        .catch(error => {
          setType('fail');
          setText(
            _.get(error, 'response.data.message', 'something went wrong!')
          );
          setShow(true);
        });
    }
  }, []);

  useEffect(() => {
    if (values.step && values.step == 'LAP') {
      setFieldValue('neededDocs', [
        'moa',
        'aoa',
        'share-holding',
        'registration-certificate'
      ]);
    } else if (_.get(preValues, 'companyDetails.companyType', false)) {
      if (
        preValues.companyDetails.companyType == 'Limited' ||
        preValues.companyDetails.companyType == 'Private Limited'
      )
        setFieldValue('neededDocs', [
          'moa',
          'aoa',
          'board-resolution',
          'share-holding',
          'registration-certificate'
        ]);
      else if (preValues.companyDetails.companyType == 'LLP') {
        setFieldValue('neededDocs', [
          'registration-certificate',
          'llp-agreement'
        ]);
      } else if (preValues.companyDetails.companyType == 'Proprietorship') {
        setFieldValue('neededDocs', ['registration-certificate']);
      } else if (preValues.companyDetails.companyType == 'Partnership') {
        setFieldValue('neededDocs', [
          'registration-certificate',
          'partnership-deed'
        ]);
      }
    }
  }, [preValues.companyDetails, values.step]);
  useEffect(() => {
    if (values.neededDocs.length > 0) {
      getSubmittedData(values.neededDocs[0]);
    }
  }, [values.neededDocs]);

  const handleConfirmationApiOnupload = (data, docName) => {
    if (!data.requestId) throw new Error(data);
    confirmBusinessAddressProofUploaded(
      getApplicantionInfo().leadId,
      getApplicantionInfo().leadApplicantId,
      data.requestId,
      docName
    )
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        setType('success');
        setText('Uploaded Successfully');
        setShow(true);
        setTimeout(() => setShow(false), 1000);
      })
      .catch(error => {
        setType('fail');
        setText(_.get(error, 'response.data.message', 'something went wrong'));
        setShow(true);
      });
  };

  const handleUploadFile = (res, index, docName) => {
    if (!_.get(res, 'url', false)) {
      throw new Error(res);
    }

    UploadFileToS3(res.url, values.file[index][0])
      .then(uploaded => {
        if (uploaded.error) {
          throw new Error(uploaded);
        }
        handleConfirmationApiOnupload(res, docName);
      })
      .catch(error => {
        setType('fail');
        setText(_.get(error, 'response.data.message', 'something went wrong'));
        setShow(true);
      });
  };
  const handleAndGetUrlForUpload = (index, docName) => {
    setType('loading');
    setText('Uploading Please Wait...');
    setShow(true);
    getUploadUrlForBusinessAddressProof(
      getApplicantionInfo().leadId,
      getApplicantionInfo().leadApplicantId,
      docName
    )
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        handleUploadFile(res, index, docName);
      })
      .catch(error => {
        setType('fail');
        setText(_.get(error, 'response.data.message', 'something went wrong'));
        setShow(true);
      });
  };

  const handleUpload = (index, docName) => {
    if (_.get(values, `file.${index}.0`, false)) {
      handleAndGetUrlForUpload(index, docName);
    }
  };

  useEffect(() => {
    handleUpload(0, 'moa');
  }, [values.file[0]]);

  useEffect(() => {
    handleUpload(1, 'aoa');
  }, [values.file[1]]);

  useEffect(() => {
    handleUpload(2, 'board-resolution');
  }, [values.file[2]]);

  useEffect(() => {
    handleUpload(3, 'share-holding');
  }, [values.file[3]]);

  useEffect(() => {
    handleUpload(4, 'registration-certificate');
  }, [values.file[4]]);

  useEffect(() => {
    handleUpload(5, 'llp-agreement');
  }, [values.file[5]]);

  useEffect(() => {
    handleUpload(6, 'partnership-deed');
  }, [values.file[6]]);

  const handleEdit = index => {
    if (index == 0) return setMOAFile(false);
    if (index == 1) return setAOAFile(false);
    if (index == 2) return setBoardRes(false);
    if (index == 3) return setShareHoldFile(false);
    if (index == 4) return setRegCertificate(false);
    if (index == 5) return setLLPINAgreement(false);
    if (index == 6) return setPartnerShipDeed(false);
  };
  const getImage = index => {
    if (index == 0) return moaFile;
    if (index == 1) return aoaFile;
    if (index == 2) return boardResFile;
    if (index == 3) return shareHoldFile;
    if (index == 4) return regCertificate;
    if (index == 5) return llpinAgreement;
    if (index == 6) return partnerShipDeed;
  };
  return (
    <div className="w-full mx-10 mt-7">
      <div className="font-roboto font-medium text-base text-black-850 my-4 px-5 ">
        Please upload your Documents
      </div>
      <div className="flex flex-wrap ">
        {requiredDocument.map((each, index) => (
          <div className="block text-left px-5 mt-2 mb-5">
            <div className="my-2 font-roboto font-normal text-grey-2100 text-sm my-3">
              {each.docname}
            </div>
            {(each.index == 6 && partnerShipDeed) ||
            (each.index == 5 && llpinAgreement) ||
            (each.index == 4 && regCertificate) ||
            (each.index == 3 && shareHoldFile) ||
            (each.index == 2 && boardResFile) ||
            (each.index == 1 && aoaFile) ||
            (each.index == 0 && moaFile) ? (
              <ShowGetImage
                img={getImage(each.index)}
                setEdit={() => handleEdit(each.index)}
              />
            ) : (
              <GlobalUploadComp
                data={values}
                imgIndex={each.index} //0,1,2,3 depending upon the no of file sequence
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                handleBlur={handleBlur}
                setFieldValue={setFieldValue}
                setFieldTouched={setFieldTouched}
                setFieldError={setFieldError}
                initialImg={initialImg} // initial image
                subInst="Click here to upload"
                subtext={each.docname}
              />
            )}
          </div>
        ))}
      </div>
      <button
        type="submit"
        className="submitButton font-roboto text-white text-base w-48 mb-10"
        disabled={Object.keys(errors).length != 0 ? true : false}
      >
        NEXT
      </button>
      <PopUp type={type} text={text} setShow={setShow} show={show} />
    </div>
  );
};

export default SENPDocuments;
